import React from 'react';
import PartsRow from './PartsRow';


function PartsTable({partsx = []}) {
      if (!partsx) {
            console.log("partsx is undefined");
            return <div>Loading...</div>;
            }

    console.log("partsx:", partsx);
            
    return (
           
        <table id="web-links">
            <caption className='caption_text'>Parts and Accessory Links </caption>   
            <thead>
                <tr>
                    <th className='type_box'>Description</th>
                    <th className='link_box'>Web Links</th>
                </tr>
            </thead>
            <tbody>
                {partsx.map((px, i) => (
                     <PartsRow partsx={px} key={i} />
                    ))}
            </tbody>
        </table>
    );
}
export default PartsTable;